export default function useDataConfiguration(props) {
  return {
    variables: {
      appointment_id: props.data.appointment.id,
    },
  }
}
